// Entry point for the build script in your package.json
import "./controllers"
import "./lib/custom-rhino-editor"

function loadDeferredFrames() {
  document.querySelectorAll('turbo-frame[data-deferred-src]').forEach(function (frame) {
    if (!frame.getAttribute('src')) {
      frame.setAttribute('src', frame.dataset.deferredSrc);
    }
  });
}

// Also listen for turbo:load so deferred frames are loaded on Turbo Drive navigations,
// which replace the body without firing DOMContentLoaded.
document.addEventListener('turbo:load', loadDeferredFrames);

document.addEventListener('DOMContentLoaded', function () {
  // Load deferred turbo frames after first paint
  requestAnimationFrame(loadDeferredFrames);

  // Add .popup class to all external links
  document.querySelectorAll('a').forEach(function (a) {
    if (a.hostname && a.hostname !== location.hostname) {
      a.classList.add('popup');
    }
  });

  // Set target and rel for .popup links
  document.querySelectorAll('a.popup').forEach(function (a) {
    a.setAttribute('target', '_blank');
    a.setAttribute('rel', 'noopener');
  });

  // Print link handler
  document.addEventListener('click', function (e) {
    if (e.target.closest('.print-link')) {
      window.print();
      e.preventDefault();
    }
  });
});
